import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 导入公共头部组件
import MedicalHeader from './components/MedicalHeader.vue'
// 全局注册组件
Vue.component('MedicalHeader', MedicalHeader)

//------------
import ElementUI from 'element-ui'
// 引入 Element UI 2.x 官方英文语言包
import enLocale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'

// 全局配置 Element UI 为英文
Vue.use(ElementUI, {
  locale: enLocale
})


//-----网络配置项
import axios from 'axios' // 网络请求项

import qs from 'qs';
Vue.prototype.$qs = qs;
Vue.prototype.$axios = axios;
Vue.prototype.$http = axios


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
